import Checkbox from "Components/Global/Form/Checkbox";

import * as S from "./styles";

const Checkboxes = ({
  label,
  items,
  selected,
  setSelected,
  columns = true,
}) => {
  return (
    <S.Wrapper>
      <label>{label}</label>
      <S.Checkboxes columns={columns}>
        {items.map((item) => (
          <Checkbox
            name={item.name}
            key={item.name}
            label={item.label}
            defaultChecked={selected?.includes(item.name)}
            onClick={(e) => {
              e.stopPropagation();

              if (e.target.checked === undefined) return;

              if (e.target.checked) {
                setSelected((prev) => [...prev, item.name]);
              } else {
                setSelected((prev) => prev.filter((i) => i !== item.name));
              }
            }}
          />
        ))}
      </S.Checkboxes>
    </S.Wrapper>
  );
};

export default Checkboxes;
